import { Timeline } from "@/lib/queries/types";
import Email from "./Email";
import RfqCreated from "./RfqCreated";
import NoteCreated from "./NoteCreated";

export default function TimelineItem({ data }: { data: Timeline }) {
  switch (data.type) {
    case "email_received":
    case "email_sent":
      return <Email data={data} />;
    case "rfq_created":
      return <RfqCreated data={data} />;
    case "note_created":
      return <NoteCreated data={data} />;
    default:
      return null;
  }
}
